import '../App.css'
import ByLaws from '../assets/documents/Region F By-Laws Revised and Adopted - March 15 2011.pdf'
import Nomination from '../assets/documents/Region F Membership Nomination Form.pdf'

export default function Planning() {

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mt-4'>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <div className='card mb-4 px-0'>
                                <div className='card-body raleway-light'>
                                    <p>
                                        The Region F Planning Group includes the following interest groups:
                                    </p>
                                    <ul>
                                        <li>Water Districts</li>
                                        <li>Water Utilities</li>
                                        <li>River Authorities</li>
                                        <li>Municipalities</li>
                                        <li>Industries</li>
                                        <li>Agriculture</li>
                                        <li>Environmental</li>
                                        <li>Small Business</li>
                                        <li>Electric Generating Utility</li>
                                        <li>Groundwater Management Areas</li>
                                        <li>Counties</li>
                                        <li>Public</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9'>
                            <h3>
                                Planning Group
                            </h3>

                            <p>
                                The Region F Water Planning Group includes a diverse group of local people representing 12 different interest categories.  The Planning Group is tasked with overseeing the development and adoption of the regional water plan in accordance with Texas Senate Bill 1 and Texas Senate Bill 2.  There are currently 23 voting members on the Region F Water Planning Group and 16 non-voting members.
                            </p>

                            <h3>
                                The Officers
                            </h3>
                            <div className='row'>
                                <div className='col-md-6'>

                                    <h5>Chairman</h5>
                                    <p>
                                        Cole Walker<br />
                                        <a href="mailto:cwalker@crmwd.org">cwalker@crmwd.org</a>
                                    </p>

                                    <h5>Secretary</h5>
                                    <p>
                                        Raymond Straub, Jr.<br />
                                        <a href="mailto:raymond@straubcorporation.org">raymond@straubcorporation.org</a>
                                    </p>

                                    <h5>Vice-Chairman</h5>
                                    <p>
                                        Scott McWilliams<br />
                                        <a href="mailto:scottm@ucratx.org">scottm@ucratx.org</a>
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <h5>At Large</h5>
                                    <p>
                                        Gilbert Van Deventer<br />
                                        Richard Gist
                                    </p>

                                    <h5>Political Subdivision </h5>
                                    <p>
                                        Colorado River Municipal Water District <br />
                                        400 E. 24th Street <br />
                                        Big Spring, TX 79720
                                    </p>

                                    <h5>Documents</h5>
                                    <p>
                                        <a href={ByLaws} target="_blank" rel="noreferrer">By-laws</a><br />
                                        <a href={Nomination} target="_blank" rel="noreferrer">Membership Nomination Form</a><br />
                                    </p>
                                </div>
                            </div>

                            <h3>
                                Members of the Region F Planning Group
                            </h3>
                            <p>
                                <a href="https://www.twdb.texas.gov/waterplanning/rwp/regions/doc/rwpg_member_report.pdf?d=29381.599999999627" target="_blank">View Members of the Region F Planning Group here</a>
                            </p>
                        </div>
                    </div>
                </div>
            </main >
        </div >
    )
}